import { UseTranslationResponse, useTranslation as useTranslationOriginal } from 'react-i18next';
import { namespacesType } from '../i18n/i18nConfigs';

// a custom hook for translation to use namespaces types when in that
export function useTranslation<N extends namespacesType = 'common'>(ns?: N): UseTranslationResponse<N, string> {
  return useTranslationOriginal(ns);
}
